import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getAreaType = async () => {
  return await get<ApiResponse<any[]>>("/areatype").then((res) => res);
};

